import { StateService } from "@uirouter/angular";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import dayjs from "@gtmhub/dayjs";
import { IPlanningSessionStats, Session } from "@webapp/sessions/models/sessions.model";

@Component({
  selector: "session-overview",
  templateUrl: "./session-overview.component.html",
  styleUrls: ["./session-overview.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SessionOverviewComponent {
  @Input()
  public stats: IPlanningSessionStats;

  @Input()
  public session: Session;

  constructor(private stateService: StateService) {}

  public daysSinceToday(date: string): number {
    return dayjs(date).diff(dayjs(), "days");
  }

  public navigateToList(statName: "goals-hit" | "metrics-hit" | "metrics-going-well" | "metrics-in-danger" | "dynamic-metrics" | "manual-metrics"): void {
    this.stateService.go("._inspect.list", { statName });
  }

  public get sessionPeriodPassedPercentageString(): string {
    const sessionStartDaysSinceToday = this.daysSinceToday(this.session.start);
    const sessionEndDaysSinceToday = this.daysSinceToday(this.session.end);

    return ((sessionStartDaysSinceToday / (sessionStartDaysSinceToday - sessionEndDaysSinceToday)) * 100).toFixed(2);
  }
}
